import React from "react";
import { TextareaAutosize } from "@mui/material";
import { makeStyles } from "@mui/styles";

import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";

import { SingleInputField, TwoInputField } from "../../../components";
import { contactUsData } from "../../../assets/lib/contactUs";

const customStyles = makeStyles({
  root: {
    padding: "100px 0px",
    width: "90%",
    maxWidth: "1216px",
    display: "flex",
    flexDirection: "column",
    margin: "0 auto",
    fontFamily: "Montserrat",
  },
  header: {
    margin: "26px 0px",
    color: "black",
    maxWidth: "50%",
    fontSize: "64px",
    fontWeight: 600,
    lineHeight: 1.1,
  },
  contactWrapper: {
    marginTop: "25px",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  contactLeft: {
    width: "55%",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
  },
  contactRight: {
    width: "40%",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
  },
  contactDetails: {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    marginTop: "48px",
  },
  contactDetailItem: {
    gap: "20px",
    color: "black",
    display: "flex",
    flexWrap: "wrap",
    fontWeight: 600,
    alignItems: "center",
    fontSize: "20px",
  },
  contactIcon: {
    padding: "8px",
    backgroundColor: "#271340",
    borderRadius: "50%",
    height: "22px",
    width: "22px",
  },
  infoWrapper: {
    padding: "40px",
    backgroundColor: "white",
    border: "1px solid #7878786B",
    borderRadius: "16px",
    boxShadow: "0px 12px 16px -4px rgba(0, 0, 0, 0.08)",
    gap: "15px",
    display: "flex",
    flexDirection: "column",
  },
  formGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  formLabel: {
    fontSize: "16px",
    fontWeight: "bold",
  },
  contactBtn: {
    width: "100%",
  },

  // Responsive breakpoints
  '@media (max-width: 480px)': {
    header: {
      fontSize: "32px",
      maxWidth: "100%",
    },
    contactWrapper: {
      flexDirection: "column",
    },
    contactLeft: {
      width: "100%",
    },
    contactRight: {
      width: "100%",
    },
    infoWrapper: {
      padding: "20px",
    },
    formLabel: {
      fontSize: "14px",
    },
  },

  '@media (min-width: 481px) and (max-width: 768px)': {
    header: {
      fontSize: "42px",
      maxWidth: "100%",
    },
    contactLeft: {
      width: "100%",
    },
    contactRight: {
      width: "100%",
    },
    infoWrapper: {
      padding: "25px",
    },
    formLabel: {
      fontSize: "15px",
    },
  },

  '@media (min-width: 769px) and (max-width: 1024px)': {
    header: {
      fontSize: "54px",
    },
    contactLeft: {
      width: "48%",
    },
    contactRight: {
      width: "48%",
    },
    infoWrapper: {
      padding: "30px",
    },
    formLabel: {
      fontSize: "16px",
    },
  },

  '@media (min-width: 1025px)': {
    header: {
      fontSize: "64px",
    },
    contactLeft: {
      width: "55%",
    },
    contactRight: {
      width: "40%",
    },
    infoWrapper: {
      padding: "40px",
    },
    formLabel: {
      fontSize: "18px",
    },
  },
});


const Layout = (props) => {
  const { contactUsState, getContactUsInput } = props;
  const classes = customStyles();
  return (
    <div className={classes.root}>
      <span className="font-size-18  purple-text">
        <span className="grey-text" style={{fontFamily: "Montserrat"}} >Home &gt; </span>
        <span  style={{fontFamily: "Montserrat",color:"black"}} >Contact Us</span>
      </span>
      <div className={classes.contactWrapper}>
        <div className={classes.contactLeft}>
          <div className="flex-direction-column gap-12">
            <span className="light-purple-text font-weight-600 font-size-18"  style={{fontFamily: "Montserrat",color:"black"}}>
              Contact
            </span>
            <span className="purple-text font-weight-600 font-size-36"  style={{fontFamily: "Montserrat",color:"black"}}>
              Don’t hesitate to reach out to us
            </span>
            <span className="grey-text font-weight-600 font-size-18"  style={{fontFamily: "Montserrat",color:"black"}}>
              Contact us anytime
            </span>
          </div>
          <div className={classes.contactDetails}>
            <div className={classes.contactDetailItem}>
              <span className={classes.contactIcon}  style={{fontFamily: "Montserrat",color:"black"}}>
                <EmailOutlinedIcon
                  fontSize="small"
                  sx={{ color: "rgb(234, 240, 131)" }}
                />
              </span>
              contact@alpaago.com
            </div>
            <div className={classes.contactDetailItem}>
              <span className={classes.contactIcon}  style={{fontFamily: "Montserrat",color:"black"}}>
                <PhoneIcon
                  fontSize="small"
                  sx={{ color: "rgb(234, 240, 131)" }}
                />
              </span>
              +91 73974 60454
            </div>
            <div className={classes.contactDetailItem}>
              <span className={classes.contactIcon}  style={{fontFamily: "Montserrat",color:"black"}}>
                <LocationOnIcon
                  fontSize="small"
                  sx={{ color: "rgb(234, 240, 131)" }}
                />
              </span>
              No 1104, 1st Main Rd, Stage I, Kengeri Satellite Town, Bengaluru,
              Karnataka 560060
            </div>
          </div>
        </div>
        <div className={classes.contactRight}>
          <div className={classes.infoWrapper}>
            <TwoInputField
            style={{fontFamily: "Montserrat",color:"black"}}
              content={contactUsData.contactName}
              value={contactUsState.contactName}
              secondContent={contactUsData.contactEmail}
              secondValue={contactUsState.contactEmail}
              getInputData={getContactUsInput}
            />
            <SingleInputField
            style={{fontFamily: "Montserrat",color:"black",}}
              content={contactUsData.contactCompany}
              value={contactUsState.contactCompany}
              getInputData={getContactUsInput}
            />
            <div className={classes.formGroup}>
              <span className={classes.formLabel} >
                {contactUsData.message.label} :
              </span>
              <TextareaAutosize
              style={{fontFamily: "Montserrat",color:"black",fontSize: "20px",}}
                aria-label="Your Message"
                placeholder={contactUsData.message.placeHolder}
                minRows={5}
                name={contactUsData.message.key}
                value={contactUsState.message}
                onChange={getContactUsInput}
              />
            </div>
            <div className={"purpleBtn"} style={{backgroundColor:"black"}}>
              <span className={classes.contactBtn}  style={{fontFamily: "Montserrat",color:"white",marginLeft:"130px"}}>Contact Us</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
